import React from 'react';
import Enumerable from 'linq';
import Functions from 'common/Functions';
import styles from './styles/Detail.sass';

class Cd extends React.Component {
  constructor() {
    super();

    this.state = {
      showAccordion: false,
    };
    this.isPc = Functions.isPc();
  }

  componentDidMount() {
    const {
      data,
      getCd,
    } = this.props;

    if (data.length < 1) {
      getCd();
    }
  }

  render() {
    const {
      data,
      match,
    } = this.props;

    if (data.length < 1) {
      return null;
    }

    const {
      imageName,
      title,
      date,
      cdNumber,
      price,
      subTitle,
      story,
      buy,
      trackList,
      youtube,
    } = data[Number(match.params.id)];
    const { showAccordion } = this.state;
    const isPc = this.isPc;

    return (
      <div className={styles.detail}>
        <header>
          <img
            src={require('images/cd-header.jpg')}
            alt='cd-header'
          />
        </header>
        <ul>
          <li className={styles.detail}>
            <div className={styles.jacket}>
              <img
                src={`/images/${imageName}`}
                alt='cd-jacket'
              />
            </div>
            <div className={styles.text}>
              <div className={styles.title}>
                {title}
              </div>
              <div className={styles.date}>
                {date}
              </div>
              <div className={styles.cd_number_price}>
                {`${cdNumber} ${price}`}
              </div>
              <ul className={styles.overview}>
                {
                  Enumerable
                    .from(subTitle)
                    .select((element, index) => (
                      <li key={index}>
                        {element}
                      </li>
                    ))
                    .toArray()
                }
              </ul>
              <ul className={styles.story}>
                {
                  Enumerable
                    .from(story)
                    .select((element, index) => (
                      <li key={index}>
                        {element}
                      </li>
                    ))
                    .toArray()
                }
              </ul>
            </div>
            <footer>
              <ul
                style={{ top: showAccordion ? 0 : buy.length * 40 }}
                onClick={
                  () => {
                    if (isPc) {
                      return false;
                    }

                    this.setState({
                      showAccordion: !this.state.showAccordion,
                    });
                  }
                }
                onMouseOver={
                  () => {
                    if (!isPc) {
                      return false;
                    }

                    this.setState({
                      showAccordion: true,
                    });
                  }
                }
                onMouseOut={
                  () => {
                    if (!isPc) {
                      return false;
                    }

                    this.setState({
                      showAccordion: false,
                    });
                  }
                }
              >
                <li>
                  購入はこちら
                </li>
                {
                  Enumerable
                    .from(buy)
                    .select((element, index) => (
                      <li key={index}>
                        <a
                          href={element.url}
                          target="_blank"
                        >
                          {element.name}
                        </a>
                      </li>
                    ))
                    .toArray()
                }
              </ul>
            </footer>
          </li>
          <li className={styles.tracklist}>
            <header>
              Track List
            </header>
            <ul>
              {
                Enumerable
                  .from(trackList)
                  .select((element, index) => (
                    <li key={index}>
                      {element}
                    </li>
                  ))
                  .toArray()
              }
            </ul>
          </li>
          {
            youtube && (
              <li className={styles.youtube}>
                <iframe src={`https://www.youtube.com/embed/${youtube.split('=')[1]}`} />
              </li>
            )
          }
        </ul>
      </div>
    );
  }
}

export default Cd



// WEBPACK FOOTER //
// src/components/cd/Detail.js